"use client";

import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
};

type InlineLoaderColor =
  | "current"
  | "default"
  | "white"
  | "gray"
  | "black"
  | "primary"
  | "muted";

const colorClasses: Record<
  InlineLoaderColor,
  { container: string; icon?: string }
> = {
  current: { container: "text-current" },
  default: { container: "text-foreground", icon: "text-primary" },
  white: { container: "text-white" },
  gray: { container: "text-gray-500" },
  black: { container: "text-black" },
  primary: { container: "text-foreground", icon: "text-primary" },
  muted: { container: "text-muted-foreground" },
};

// インラインローダー用（ボタン内など）
export function InlineLoader({
  text = "処理中...",
  size = "sm",
  className,
  color = "current",
}: {
  text?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
  color?: InlineLoaderColor;
}) {
  const colors = colorClasses[color];

  return (
    <div className={cn("flex items-center gap-2", colors.container, className)}>
      <Loader2 className={cn("animate-spin", sizeClasses[size], colors.icon)} />
      <span>{text}</span>
    </div>
  );
}
